module.exports = __webpack_public_path__ + "img/131ne.aecbe926.svg";